import { lazy } from 'react';
const LazySearchPage = /*#__PURE__*/lazy(() => import( /* webpackChunkName: "async-ptc_search-page" */'./'));
export default LazySearchPage;